import { useCallback } from 'react';

import { Locale } from '../types/localization';
import { setLocaleCookie } from './cookies';
import { useUniversalRouter } from './useUniversalRouter';

export function useLocaleChanger() {
  const router = useUniversalRouter();

  return useCallback(
    (locale: string) => {
      setLocaleCookie(locale as Locale);
      router?.push('/');
    },
    [router]
  );
}
